import {
  jb_button_panel_css_default
} from "./chunk.FTM3AYDI.js";
import {
  e
} from "./chunk.3XLWIJBS.js";
import {
  reset_css_default
} from "./chunk.YAATWOBE.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  n
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-button-panel/jb-button-panel.ts
var JbButtonPanel = class extends i {
  constructor() {
    super(...arguments);
    this.align = "left";
  }
  render() {
    this.align = this.align || "left";
    return b`<div class=${e({ [`${this.align}-aligned`]: true })}>
      <slot></slot>
    </div>`;
  }
};
JbButtonPanel.styles = [reset_css_default, jb_button_panel_css_default];
__decorateClass([
  n()
], JbButtonPanel.prototype, "align", 2);
JbButtonPanel = __decorateClass([
  customElement("jb-button-panel")
], JbButtonPanel);

export {
  JbButtonPanel
};
